import fetchApi from 'services/api/connector';

export const getCustomFilters = () => fetchApi('searchfilter');
export const getModelFields = () => fetchApi('jobs/rules/attributes');
export const createCustomFilter = (data) => fetchApi('searchfilter', { method: 'POST', data });
export const removeCustomFilter = (id) => fetchApi(`searchfilter/${id}`, { method: 'DELETE' });
export const searchCustomFilter = (id) => fetchApi(`searchfilter/${id}`);
export const updateCustomFilter = (id, data) => fetchApi(`searchfilter/${id}`, { method: 'PATCH', data });
export const replaceCustomFilter = (id, data) => fetchApi(`searchfilter/${id}`, { method: 'PUT', data });
